import type { TAuthConfig, TAuthEnv } from "./auth-config.types";

let overrideConfig: Partial<TAuthConfig> | null = null;

const getEnvVar = (key: string, fallback: string): string => {
  if (import.meta !== undefined) {
    const value = import.meta?.env?.[key] as string | undefined;
    if (value) return value;
  }
  return fallback;
};

const ENV_PRESETS: Record<TAuthEnv, TAuthConfig> = {
  production: {
    cookieJwtName: "webmotors.jwt.token",
    cookieRefreshName: "webmotors.refresh.token",
    cookieAccessName: "webmotors.access.token",
    cookieUserHash: "webmotors.user.hash",
    loginUrl: "https://www.webmotors.com.br/login/",
    apiUrl: "https://www.webmotors.com.br/api/",
    cookieDomain: ".webmotors.com.br",
  },
  homologation: {
    cookieJwtName: "webmotors.jwt.token.hk",
    cookieRefreshName: "webmotors.refresh.token.hk",
    cookieAccessName: "webmotors.access.token",
    cookieUserHash: "webmotors.user.hash",
    loginUrl: "https://hportal.webmotors.com.br/login/",
    apiUrl: "https://hportal.webmotors.com.br/api/",
    cookieDomain: ".webmotors.com.br",
  },
  development: {
    cookieJwtName: "webmotors.jwt.token",
    cookieRefreshName: "webmotors.refresh.token",
    cookieAccessName: "webmotors.access.token",
    cookieUserHash: "webmotors.user.hash",
    loginUrl: "http://localhost:3000/login/",
    apiUrl: "https://hportal.webmotors.com.br/api/",
    cookieDomain: "localhost",
  },
};

const resolveEnv = (): TAuthEnv => {
  const envVar = getEnvVar("VITE_AUTH_ENV", "");
  if (envVar && envVar in ENV_PRESETS) return envVar as TAuthEnv;
  return "production";
};

export const configureAuth = (
  config: Partial<TAuthConfig> & { env?: TAuthEnv },
): void => {
  const { env, ...rest } = config;

  if (env) {
    overrideConfig = { ...ENV_PRESETS[env], ...overrideConfig, ...rest };
  } else {
    overrideConfig = { ...overrideConfig, ...rest };
  }
};

export const resetAuthConfig = (): void => {
  overrideConfig = null;
};

export const getAuthConfig = (): TAuthConfig => {
  const env = resolveEnv();
  const preset = ENV_PRESETS[env];

  const defaults: TAuthConfig = {
    cookieJwtName: getEnvVar("VITE_COOKIE_JWT_NAME", preset.cookieJwtName),
    cookieRefreshName: getEnvVar(
      "VITE_COOKIE_REFRESH_NAME",
      preset.cookieRefreshName,
    ),
    cookieAccessName: getEnvVar(
      "VITE_COOKIE_ACCESS_NAME",
      preset.cookieAccessName,
    ),
    cookieUserHash: getEnvVar("VITE_COOKIE_USER_HASH", preset.cookieUserHash),
    loginUrl: getEnvVar("VITE_AUTH_LOGIN_URL", preset.loginUrl),
    apiUrl: getEnvVar("VITE_AUTH_API_URL", preset.apiUrl),
    cookieDomain: getEnvVar("VITE_COOKIE_DOMAIN", preset.cookieDomain),
  };

  if (!overrideConfig) return defaults;

  return { ...defaults, ...overrideConfig };
};
